import { render } from "./B2bPageEstadisticasTopSeller.vue?vue&type=template&id=40f0f57b&scoped=true&lang=pug"
import script from "./B2bPageEstadisticasTopSeller.vue?vue&type=script&lang=js"
export * from "./B2bPageEstadisticasTopSeller.vue?vue&type=script&lang=js"

import "./B2bPageEstadisticasTopSeller.vue?vue&type=style&index=0&id=40f0f57b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f0f57b"]])

export default __exports__